import React from 'react';
import { useTranslation } from 'react-i18next';
import HeroImg from '../../../assets/images/company-formation/hong-kong-offshore-company.png';
import BannerImg from '../../../assets/images/company-formation/hong-kong-offshore-company-banner.png';
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../../components/Constant/button/Button";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";
import SEO from "../../../utils/SEO";

export default function HongKongOffshoreCompany() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.hong-kong-offshore-company.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });
    const withIcon = (k, icon) => (obj(k) || []).map((it) => ({ ...it, icon }));

    const BreadCrumbsData = [
        { name: tp('breadcrumb.home', 'Offshore Advisory'), link: '/' },
        { name: tp('breadcrumb.self', 'Hong Kong Company Formation'), link: '/hong-kong-offshore-company' },
    ];

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/hong-kong-offshore-company"
            />
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>{tp('h1')}</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>{tp('subtitle')}</h3>
                            <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('intro') }} />

                            <PageList items={(obj('checklist') || []).map((title) => ({ title, icon: TiTick }))} />

                            <Button
                                text={tp('proposalButton')}
                                link="/quote"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        {/* Why Choose Hong Kong */}
                        <h3 className='page-title'>{tp('why.title')}</h3>
                        <PageList items={withIcon('why.items', GoDotFill)} />

                        {/* Benefits */}
                        <h3 className='page-title'>{tp('benefits.title')}</h3>
                        <PageList items={withIcon('benefits.items', GoDotFill)} />

                        {/* What's Included */}
                        <h3 className='page-title'>{tp('requirements.title')}</h3>
                        <PageList items={withIcon('requirements.items', GoDotFill)} />

                        {/* Banking Section */}
                        <h3 className='page-title'>{tp('banking.title')}</h3>
                        <p className='page-subtitle'>{tp('banking.subtitle')}</p>
                        <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('banking.intro') }} />
                        
                        {/* Banking Disclaimer Card */}
                        <div className='timeline-card' style={{ background: '#FFFBEB', border: '2px solid #FDE68A', padding: '24px', borderRadius: '8px', margin: '20px 0' }}>
                            <h4 className='timeline-card-title' style={{ color: '#92400E', marginBottom: '12px' }}>{tp('banking.disclaimerTitle')}</h4>
                            <p className='timeline-card-text' style={{ color: '#78350F' }} dangerouslySetInnerHTML={{ __html: tp('banking.disclaimerText') }} />
                        </div>

                        {/* Who Can Set Up */}
                        <h3 className='page-title'>{tp('uses.title')}</h3>
                        <PageList items={withIcon('uses.items', GoDotFill)} />

                        {/* How it Works */}
                        <h3 className='page-title'>{tp('process.title')}</h3>
                        <PageList items={withIcon('process.items', GoDotFill)} />

                        {/* Documents You May Need */}
                        <h3 className='page-title'>{tp('requirementsDocs.title')}</h3>
                        <p className='page-subtitle'>{tp('requirementsDocs.subtitle')}</p>
                        <PageList items={withIcon('requirementsDocs.items', GoDotFill)} />
                        
                        <p className='page-subtitle' style={{ marginTop: '24px' }}>{tp('requirementsDocs.infoTitle')}</p>
                        <p className='page-paragraph'>{tp('requirementsDocs.infoText')}</p>

                        {/* Costs */}
                        <h3 className='page-title'>{tp('costs.title')}</h3>
                        <p className='page-subtitle'>{tp('costs.subtitle')}</p>
                        <PageList items={withIcon('costs.items', GoDotFill)} />
                        <p className='page-paragraph' style={{ marginTop: '12px' }}>{tp('costs.end')}</p>

                        {/* Compliance */}
                        <h3 className='page-title'>{tp('compliance.title')}</h3>
                        <p className='page-subtitle'>{tp('compliance.subtitle')}</p>
                        <PageList items={withIcon('compliance.items', GoDotFill)} />
                    </div>

                    <FAQList title={tp('faq.title')} data={obj('faq.items')} />

                    <Testimonials title={tp('testimonials.title')} testimonials={obj('testimonials.items')}/>

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
}
